import { render, staticRenderFns } from "./Simulasi.vue?vue&type=template&id=2af53526&scoped=true&"
import script from "./Simulasi.vue?vue&type=script&lang=js&"
export * from "./Simulasi.vue?vue&type=script&lang=js&"
import style0 from "./Simulasi.vue?vue&type=style&index=0&id=2af53526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af53526",
  null
  
)

export default component.exports